import {Roles} from 'app/Constants';
import IntegrityRoleGrid from 'components/UserRole';
import {Column} from 'devextreme-react/data-grid';
import React from 'react';
import {i18n2} from '../../i18n/i18n';
import {
  useAddTurn,
  useDeleteTurn,
  useLoadTurn,
  useUpdateTurn,
} from '../hooks/index';
import {TurnSchema} from '../model/Turn';
import IntegrityTurnGrid from './IntegrityTurnGrid';

const columnOptions = [
  {
    column: 'iD_Shift',
    allowEdit: false,
    hiddenAdd: true,
  },
  {
    column: 'name',
    sizeMobile: 12,
    sizeDesktop: 6,
    required: true,
  },
  {
    column: 'schedule',
    sizeMobile: 12,
    sizeDesktop: 6,
    required: true,
  },
];

const TurnGrid = () => {
  const loadTurn = useLoadTurn();
  const addTurn = useAddTurn();
  const updateTurn = useUpdateTurn();
  const deleteTurn = useDeleteTurn();

  return (
    <IntegrityRoleGrid
      allowEdit={[Roles.AdminITPS, Roles.AdminQA]}
      schema={TurnSchema()}
      dataSource={loadTurn}
      promiseAdd={addTurn}
      promiseEdit={updateTurn}
      promiseDelete={deleteTurn}
      id={['iD_Shift']}
      integrityId={['ID_Shift']}
      integrityName={'Shift'}
      exportName="Shift-export"
      integrityGrid={IntegrityTurnGrid}
      columnOptions={columnOptions}>
      <Column caption={i18n2._('#Shift')} dataField="iD_Shift" />
      <Column caption={i18n2._('Nombre')} dataField="name" />
      <Column
        caption={i18n2._('Horario')}
        dataField="schedule"
        defaultSortOrder={'asc'}
      />
      <Column caption={i18n2._('Revision')} dataField="revision" />
      <Column caption={i18n2._('Motivo')} dataField="reason" />
      <Column
        caption={i18n2._('Fecha de actualizacion')}
        dataField="updateDate"
        dataType="date"
        format="dd/MM/yyyy"
        calculateCellValue={(row: any) => new Date(row.updateDate)}
      />
      <Column caption={i18n2._('Actualizado por')} dataField="updatedBy" />
      <Column caption={i18n2._('Eliminado')} dataField="deleted" width={100} />
    </IntegrityRoleGrid>
  );
};

export default TurnGrid;
